import { useCallback } from 'react';
import { Card, Link, styled, Typography } from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { extractErrorMessage } from 'app/providers/with-wagmi-auth/utils';
import { referrerModel } from 'entities/referrer';
import { selectReferrerState } from 'entities/referrer/model';
import {
  COLOR_BG_BLACK,
  COLOR_SECONDARY,
  cratChain,
  cratChainNativeToken,
  getToastMessage,
  TokenFormat,
  useAppDispatch,
  useInterval,
  useShallowSelector,
} from 'shared';
import { AwaitableButton, NetworkGuardedButton } from 'shared/ui/buttons';
import { Address } from 'viem';

import { PAYOUT_CONVERSION_FORM_LINK } from '../../constants';

const BlackCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: COLOR_BG_BLACK,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(1, 2),
}));

export const ReferralClaim = () => {
  const { state } = useWagmiAuth();
  const dispatch = useAppDispatch();
  const referrerState = useShallowSelector(selectReferrerState);

  const claimReward = useCallback(async () => {
    if (!state.address) return;

    try {
      await dispatch(referrerModel.thunks.claimReward(state.address)).unwrap();
    } catch (error) {
      getToastMessage('error', extractErrorMessage(error));
    }
  }, [dispatch, state.address]);

  useInterval(() => dispatch(referrerModel.thunks.getClaimableAmount(state.address as Address)), 80_000);

  return (
    <BlackCard sx={{ flex: 1, px: 2, py: 1.5, alignItems: 'center', borderRadius: 3 }}>
      <Typography variant="body2" className="secondary" mb={2}>
        CRAT available for claim:
      </Typography>

      <Typography variant="h4" className="primary" mb={2}>
        <TokenFormat
          amount={referrerState.claimableAmount}
          decimals={cratChainNativeToken.decimals}
          maxDecimalDigits={4}
          symbol="CRAT"
          variant="h4"
        />
      </Typography>

      <NetworkGuardedButton targetChainId={cratChain.id} variant="contained" fullWidth>
        <AwaitableButton action={claimReward} disabled={!+referrerState.claimableAmount} variant="contained" fullWidth>
          Claim
        </AwaitableButton>
      </NetworkGuardedButton>

      <Link
        href={PAYOUT_CONVERSION_FORM_LINK}
        target="_blank"
        variant="body2"
        color={COLOR_SECONDARY}
        textAlign="center"
        sx={{ mt: 1 }}
      >
        Payout Conversion Form (USDT/USDC)
      </Link>
    </BlackCard>
  );
};
